import React from "react";
import { TableColumnsItem } from "../../interfaces/components/mainTable";
import { ColumnType, ButtonType } from "../utils/enums";
import { Currency } from "../../interfaces/screens/billing";
import { CheckCircle2, Edit, Trash } from "lucide-react";

interface CurrencyColumnHandlers {
  onEdit: (currency: Currency) => void;
  onSetDefault: (currency: Currency) => void;
  onDelete: (currency: Currency) => void;
}

export const getCurrenciesTableColumns = (
  handlers: CurrencyColumnHandlers,
): TableColumnsItem[] => [
  { key: "name", name: "Name", type: ColumnType.TEXT },
  { key: "code", name: "Code", type: ColumnType.TEXT },
  { key: "exchange_rate", name: "Exchange Rate", type: ColumnType.TEXT },
  {
    key: "is_default",
    name: "Default",
    type: ColumnType.CUSTOM,
    customValue: (row: Currency) =>
      row.is_default ? <CheckCircle2 className="text-green-500" /> : null,
  },
  {
    key: "actions",
    name: "Actions",
    type: ColumnType.BUTTON,
    buttonsList: [
      {
        type: ButtonType.ICON,
        icon: Edit,
        onPress: (e: React.MouseEvent, row: Currency) => handlers.onEdit(row),
      },
      {
        type: ButtonType.ICON,
        icon: CheckCircle2,
        onPress: (e: React.MouseEvent, row: Currency) =>
          handlers.onSetDefault(row),
        tooltip: "Set as Default",
      },
      {
        type: ButtonType.ICON,
        icon: Trash,
        cssClass: "delete",
        onPress: (e: React.MouseEvent, row: Currency) =>
          handlers.onDelete(row),
      },
    ],
  },
];
